import { service } from '../index.js'

// 商品管理
export const product = {
  // 列表（后台）
  list: ({ params = {} } = {}) => {
    return service.get('/product/admin/list', { params })
  },
  
  // 详情
  get: (params) => {
    return service.get('/product/detail', { params })
  },
  
  // 保存（新增/编辑共用）
  save: (data) => {
    return service.post('/product/admin/save', data)
  },
  
  // 切换状态
  toggleStatus: (data) => {
    return service.post('/product/admin/toggle-status', data)
  },
  
  // 删除
  delete: (params) => {
    return service.post('/product/admin/delete', params)
  },

  // 热门商品
  hot: (params) => {
    return service.get('/product/hot', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/product.js